import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import role from "../../../../assets/svg/role.svg";
import $ from "jquery";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import note from "../../../../assets/svg/note.svg";
import { rightBarClose } from "../../../../redux/action/Action";
import versionBlack from "../../../../assets/svg/versionBlack.svg";
import {
  GET_DOCUMENT_BY_ID,
  GET_VERSION_LOG,
  GET_FILES_URL,
  POST_UPDATE_DOC_PASSWORD,
} from "../../../../helpers/endpointService";
import Moment from "moment";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { logoutFunction, CheckPasswordValid } from "../../../custom/commonFunction";
import url from "../../../../assets/svg/url.svg";
import FileIcon from "../../../pages/documents/folder/FileIcon";
import formats from "../../../../helpers/MediaFormats";
import AudioPopup from "../../layout/AudioPop";
import VideoPop from "../../layout/VideoPop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import lock from "../../../../assets/svg/lock.svg";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import RenewIcon from "../../../../assets/svg/ButtonRenewIcon.svg";
import ButtonBackIcon from "../../../../assets/svg/ButtonBackIcon.svg";
import UserRole from "../../../../helpers/role";

const versionFileSchema = [
  {
    id: 703,
    fileName: "audio-file.mp3",
    fileType: "audio/mpeg",
    fileUrl:
      "https://fujitecdocumentssit.blob.core.windows.net/document/1786_DMS_01_020001 Ver 1/audio-file.mp3",
    fileSize: 733645,
    isFavourite: false,
    fileOrder: 1,
  },
  {
    id: 704,
    fileName: "video-file.mp4",
    fileType: "video/mp4",
    fileUrl:
      "https://fujitecdocumentssit.blob.core.windows.net/document/1786_DMS_01_020001 Ver 1/video-file.mp4",
    fileSize: 1570024,
    isFavourite: false,
    fileOrder: 2,
  },
  {
    id: 705,
    fileName: "word-doc.docx",
    fileType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    fileUrl:
      "https://fujitecdocumentssit.blob.core.windows.net/document/1786_DMS_01_020001 Ver 1/word-doc.docx",
    fileSize: 219021,
    isFavourite: false,
    fileOrder: 3,
  },
];
export default function Properties({ rightbarOpen, rightbarId }) {
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("Role");
  const [docProp, setDocProp] = useState();
  const [docVersion, setDocVersion] = useState();
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);
  const [versionDocLoader, setVersionDocLoader] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [isMobile, setisMobile] = useState(false);
  const [isPlayVideo, setPlayVideo] = useState(false);
  const [isPlayAudio, setPlayAudio] = useState(false);
  const [videoSrc, setVideoSrc] = useState();
  const [audioSrc, setAudioSrc] = useState("");

  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [docPassword, setDocPassword] = useState("Qantler@1234");
  const userId = localStorage.getItem("UserId");

  // const [isLoader, setLoader] = useState(false);

  const changePassword = () => {
    setIsChangePassword(true);
    setIsPasswordProtected(docProp?.isPasswordProtected);
    setNewPasswordValue("");
    setConfirmPasswordValue("");
    setTimeout(() => {
      if(docProp?.isPasswordProtected == true){
        $('.password-checkbox').prop('checked', true);
      }else {
        $('.password-checkbox').prop('checked', false);
      }
    }, 10)
  };
  const handleCancelUpdatePassword = () => {
    setIsChangePassword(false);
    setNewPasswordValue("");
    setIsPasswordProtected(docProp?.isPasswordProtected);
    setDocPassword(docProp?.password);
  };
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleCheckboxChange = (event) => {
    setIsPasswordProtected(event.target.checked);
  };

  const handleUpdatePassword = () => {
    const checkPassword = CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue);
    let obj = {
      documentId: docProp?.id,
      isPasswordProtected: isPasswordProtected,
      password:
        isPasswordProtected == true ? window.btoa(newPasswordValue) : "",
      userId: userId,
    };
    if (checkPassword == true) {
      setPropertyLoader(true);
      axios
        .patch(POST_UPDATE_DOC_PASSWORD, obj)
        .then((response) => {
          if (response?.status === 200) {
            setIsChangePassword(false);
            setDocPassword(newPasswordValue);
            setDocProp({
              ...docProp,
              isPasswordProtected: isPasswordProtected,
              password: window.btoa(newPasswordValue),
            });
            toast.success("Document password updated successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setPropertyLoader(false);
          } else {
            setPropertyLoader(false);
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          logoutFunction(err?.response?.status);
        });
    } else {
    }
  };

  useEffect(() => {
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    const intervals = setInterval(() => {
      resize();
    }, 10);
    const fetchData = async () => {
      let propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${rightbarId}`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            fetchVersion();
            setDocProp(response.data);
            setDocPassword(response?.data?.password);
            if (response?.data?.isPasswordProtected) {
              setIsPasswordProtected(response?.data?.isPasswordProtected);
            } else {
              setIsPasswordProtected(response?.data?.isPasswordProtected);
            }
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchData();

    const resize = () => {
      if (window.innerWidth < 300) {
        setisSmallMobile(true);
      } else {
        setisSmallMobile(false);
      }
      if (window.innerWidth < 850) {
        setisMobile(true);
      } else {
        setisMobile(false);
      }
    };

    const fetchVersion = async () => {
      let versionApiUrl = `${GET_VERSION_LOG}?docId=${rightbarId}`;
      await axios
        .get(versionApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setDocVersion(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };
  }, [rightbarId]);

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  const handleFileOpen = (id, type) => {
    if (id) {
      //setLoader(true);
      setPropertyLoader(true);
      let fileUrl = null;
      const fetchFileUrl = async () => {
        let fileSrcUrl = `${GET_FILES_URL}?fileId=${id}`;
        await axios
          .get(fileSrcUrl)
          .then((response) => {
            if (response?.status === 200) {
              fileUrl = response.data;
              setPropertyLoader(false);
              if (fileUrl) {
                const fileType =
                  type === "url" ? type : fileUrl.split(".").pop();
                const supportedFormats = Object.values(formats).flat();

                if (supportedFormats.includes(fileType)) {
                  const findKeyByValue = (value, obj) => {
                    for (let key in obj) {
                      if (obj[key].includes(value)) {
                        return key;
                      }
                    }
                    return null;
                  };

                  const fileTypeKey = findKeyByValue(fileType, formats);

                  if (fileTypeKey) {
                    switch (fileTypeKey) {
                      case "video":
                        setPlayVideo(true);
                        setVideoSrc(fileUrl);
                        break;
                      case "audio":
                        setPlayAudio(true);
                        setAudioSrc(fileUrl);
                        break;
                      case "word":
                      case "pdf":
                      case "ppt":
                      case "zip":
                      case "xlsx":
                      case "image":
                      case "url":
                        window.open(fileUrl);
                        break;
                      default:
                        console.error(`Unsupported file type: ${fileType}`);
                    }
                    return;
                  } else {
                    console.error(`Unsupported file type: ${fileType}`);
                  }
                } else {
                  //console.error(`Unsupported file type: ${fileType}`);
                  toast.error(fileType, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                  });
                }
              }
            }
          })
          .catch((err) => {
            setPropertyLoader(false);
            logoutFunction(err?.response?.status);
          });
      };
      fetchFileUrl();
    }
  };

  ////////////////////////////////////////  Media popup close /////////////////////////////////
  const handleCloseModal = () => {
    setPlayAudio(false);
    setPlayVideo(false);
  };

  return (
    <>
      <div
        className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="loader-new-1">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        )}

        {isPropertyFailed && (
          <div className="loader-new-1">
            <span>Loading failed</span>
          </div>
        )}

        <div className="viewMain">
          <div className="viewTitle">
            <span>{docProp?.documentNo}</span>
            {!isPropertyLoader && (
              <span className="close mt-2" onClick={close}>
                ✕
              </span>
            )}
          </div>
          {docProp && (
            <div className="inputSection">
              <div className="row">
                <div className="col-sm-6 col-12">
                  <span>
                    <img
                      style={{
                        position: "relative",
                        top: "-1px",
                        fontSize: "14px",
                      }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    <span className="text-14-bold">Document no.</span>
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.documentNo}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={file} alt="" />
                    <span className="text-14-bold"> Document name</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.documentName}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={role} alt="" />
                    <span className="text-14-bold"> Author</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.authorName}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={infoBlack} alt="" className="mt-1" />
                    <span className="text-14-bold"> Version</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.version}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span className="text-14-bold"> Category 1</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.category1Name}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span className="text-14-bold"> Category 2</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.category2Name}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" className="mt-1" />
                    <span className="text-14-bold"> Published date</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.publishedDate
                      ? Moment(docProp.publishedDate).format("DD-MMM-YYYY")
                      : "-"}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" className="mt-1" />
                    <span className="text-14-bold"> Expiry date</span>
                  </div>
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#605E5C",
                      fontSize: "14px",
                    }}
                  >
                    {docProp.reviewDate
                      ? Moment(docProp.reviewDate).format("DD-MMM-YYYY")
                      : "-"}
                  </span>
                </div>
              </div>
              {userRole === UserRole.ADMIN && (
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="inputTitle">
                      <img src={infoBlack} alt="" />
                      <span className="text-14-bold">Status</span>
                    </div>
                    <span
                      style={{
                        fontWeight: "400",
                        color:
                          docProp.status === "Active"
                            ? "#21A366"
                            : docProp.status === "Obsolete"
                            ? "#D12232"
                            : "#FF9000",
                      }}
                    >
                      {docProp.status}
                    </span>
                  </div>
                </div>
              )}
              <div className="col-12 py-3">
                <div className="inputTitle">
                  <img src={note} alt="" />
                  <span className="text-14-bold"> Note</span>
                </div>
                <span
                  style={{
                    fontWeight: "400",
                    color: "#605E5C",
                    fontSize: "14px",
                  }}
                >
                  {docProp.remarks}
                </span>
              </div>

              <div className="row">
                <div
                  className={
                    isChangePassword == false
                      ? "col-12 password-rowspace"
                      : "col-12 password-rowspace"
                  }
                >
                  <div className="inputTitle">
                    {isChangePassword == false ? 
                      <img src={lock} className="password-icon" alt="" />
                       : 
                      <input
                        type="checkbox"
                        className="password-checkbox margin-top4"
                        name="request"
                        onChange={(e) => handleCheckboxChange(e)}
                      />
                    } 
                    <span
                      className={
                        isChangePassword == false
                          ? "text-14-bold"
                          : "text-14-bold password-text "
                      }
                    >
                      Is password protected?
                    </span>
                  </div>
                  {isChangePassword == false && (
                    <span className="view-answer">
                      {isPasswordProtected == true ? "Yes" : "No"}
                    </span>
                  )}
                </div>
              </div>
              {isChangePassword == false &&
                isPasswordProtected == true &&
                userRole == UserRole.ADMIN && (
                  <div className="row">
                    <div className="col-12 password-rowspace">
                      <div className="inputTitle">
                        <img src={lock} className="password-icon" alt="" />
                        <span className="text-14-bold"> Password</span>
                      </div>
                      <span className="view-answer">
                        {newPasswordValue != ""
                          ? newPasswordValue
                          : window.atob(docProp?.password)}
                      </span>
                    </div>
                  </div>
                )}
              {isPasswordProtected == true && isChangePassword == true && (
                <>
                  <div className="row">
                    <div className="col-12 password-rowspace">
                      <div className="inputTitle">
                        <img src={lock} className="password-icon" alt="" />
                        <span className="text-14-bold">
                          {" "}
                          New password
                          <span className="required-color padding-left2">
                            *
                          </span>
                        </span>
                      </div>
                      <FormControl variant="outlined" className="w-100 mt-2">
                        <OutlinedInput
                          type={showNewPassword ? "text" : "password"}
                          className="password-inputs newdoc-newpassword"
                          id="newdoc-newpasswordid"
                          value={newPasswordValue}
                          onChange={(e) => setNewPasswordValue(e.target.value)}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowNewPassword}
                                edge="end"
                              >
                                {showNewPassword ? (
                                  <VisibilityOff className="eye-password-icon" />
                                ) : (
                                  <Visibility className="eye-password-icon" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <div className="mt-0 font-13">
                        <span
                          className="required-color font-weight400 newPasswordErrorText"
                          id="newPasswordErrorText"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 password-rowspace">
                      <div className="inputTitle">
                        <img src={lock} className="password-icon" alt="" />
                        <span className="text-14-bold">
                          {" "}
                          Confirm password
                          <span className="required-color padding-left2">
                            *
                          </span>
                        </span>
                      </div>
                      <FormControl variant="outlined" className="w-100 mt-2">
                        <OutlinedInput
                          type={showConfirmPassword ? "text" : "password"}
                          className="password-inputs newdoc-confirmpassword"
                          id="newdoc-confirmpasswordid"
                          value={confirmPasswordValue}
                          onChange={(e) =>
                            setConfirmPasswordValue(e.target.value)
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowConfirmPassword}
                                edge="end"
                              >
                                {showConfirmPassword ? (
                                  <VisibilityOff className="eye-password-icon" />
                                ) : (
                                  <Visibility className="eye-password-icon" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <div className="mt-0 font-13">
                        <span
                          className="required-color font-weight400 confirmPasswordErrorText"
                          id="confirmPasswordErrorText"
                        ></span>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {userRole == UserRole.ADMIN && (
                <div className="row">
                  <div className="col-12 d-flex gap-2 password-rowspace">
                  {isChangePassword == false &&
                  <button
                      onClick={() => changePassword()}
                      className={`btn btn-light input-group button-style-theme px-3 py-2 filter-nextbtn border border-3 border-danger` }
                      style={{height:"40px"}}
                    >
                      <img alt="" src={RenewIcon} className="modal-img"></img>
                      <span className="model-label pl-5">Change</span>
                    </button>
                  }
                  {isChangePassword == true && <>
                    <button
                      onClick={() => handleUpdatePassword()}
                      className={`btn btn-light input-group button-style-theme px-3 py-2 filter-nextbtn border border-3 border-danger` }
                      style={{height:"40px"}}
                    >
                      <img alt="" src={RenewIcon} className="modal-img"></img>
                      <span className="model-label pl-5">Update</span>
                    </button>
                    <button
                      onClick={() => handleCancelUpdatePassword()}
                      className={`btn btn-light input-group button-style-white px-4 py-2`}
                    >
                      <img
                        alt=""
                        src={ButtonBackIcon}
                        className="modal-img"
                      ></img>
                      <span className="model-backlabel pl-5">Cancel</span>
                    </button>
                    </>}
                  </div>
                </div>
              )}
              <div className="row mt-1">
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img className="properties-img" src={versionBlack} />{" "}
                      <span className="pl-10 properties-span text-14-bold">
                        Versions
                      </span>
                    </label>
                    <div className="table-responsive mb-4 mt-3">
                      <table id="versionTable" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Versions
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Author
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Publisheddate-width" : ""
                              } no-wrap`}
                            >
                              Published date/time
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Checker
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Approver
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {docVersion && docVersion?.length !== 0 ? (
                            docVersion?.map((i, index) => (
                              <tr id={index} key={index}>
                                <td className="no-wrap">
                                  <span
                                  // data-bs-toggle="offcanvas"
                                  // data-bs-target="#offcanvasVersion"
                                  // aria-controls="offcanvasVersion"
                                  >
                                    {i.documentVersion}
                                  </span>
                                </td>
                                <td className="no-wrap">{i.authorName}</td>
                                <td className="no-wrap">
                                  {i.publishedDate
                                    ? Moment(
                                        new Date(Date.parse(i.publishedDate))
                                      ).format("DD-MMM-YYYY h:mm A")
                                    : ""}
                                </td>
                                <td className="no-wrap">{i.checkerName}</td>
                                <td className="no-wrap">{i.approverName}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="table-noversion" colSpan={5}>
                                No version history
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasVersion"
          aria-labelledby="offcanvasRightLabel"
        >
          {versionDocLoader ? (
            <div className="loader-new-1">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          ) : (
            <>
              {/* <ToastContainer limit={1} className="ml-1" /> */}
              <div className="offcanvas-header mt-4">
                <div className="viewTitle">
                  <span>Ver 1 Documnets</span>
                </div>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
              <div className="offcanvas-body">
                <div className="table-responsive">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          File Name
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionFileSchema?.map((list, index) => {
                        return (
                          <tr
                            key={
                              index
                            } /* onDoubleClick={() => handleChangeChecked(list.id)} */
                          >
                            <td
                              style={{ display: "flex" }}
                              title={list.fileName}
                            >
                              <div style={{ paddingRight: "10px" }}>
                                {list.fileType === "url" ? (
                                  <img src={url} alt="" />
                                ) : (
                                  <FileIcon fileName={list.fileName} />
                                )}
                              </div>
                              <span
                                onClick={() =>
                                  handleFileOpen(list.id, list.fileType)
                                }
                                className="fileName"
                              >
                                {list.fileName}
                              </span>
                            </td>

                            <td></td>
                            {/* {list.isFavourite && <img style={{ right: "50px", position: 'relative' }} src={fav} width={18} />} */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {isPlayVideo && (
        <VideoPop videoUrl={videoSrc} onClose={handleCloseModal} />
      )}

      {isPlayAudio && (
        <AudioPopup audioUrl={audioSrc} onClose={handleCloseModal} />
      )}
    </>
  );
}
